export function RightArrowSvg({ className, classNameArrow }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="32" height="32" rx="16" fill="#0F9ED9" />
      <rect x="8.5" y="15" width="15" height="2" rx="1" fill="white" className={classNameArrow} />
      <path className={classNameArrow}
        d="M16.32 9.81999C16.7122 9.42786 17.3479 9.42786 17.74 9.81999L22.33 14.41C22.9155 14.9954 22.9155 15.9446 22.33 16.53L21.97 16.89L16.32 11.24C15.9279 10.8479 15.9279 10.2121 16.32 9.81999Z"
        fill="white"
      />
      <path className={classNameArrow}
        d="M16.3201 22.18C15.928 21.7878 15.928 21.1521 16.3201 20.76L21.9751 15.105L22.3343 15.4641C22.9202 16.05 22.9202 16.9999 22.3343 17.5858L17.7401 22.18C17.348 22.5721 16.7122 22.5721 16.3201 22.18Z"
        fill="white"
      />
    </svg>
  );
}

// Add more icons below, e.g.:
// export function ChevronDown({ className }) { ... }
// export function CloseIcon({ className }) { ... }
